import styled from "styled-components"

import { MEDIA_QUERIES } from "@constants"

export const InterviewBuilderAppGridDIV = styled.div`
  max-width: 100%;

  ${MEDIA_QUERIES.M} {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: var(--spacing--XS);
    padding: 0 15px; // To offset negative margins from Row component
  }

  ${MEDIA_QUERIES.L} {
    gap: var(--spacing--S);
  }
`